import * as React from "react";
import type { SVGProps } from "react";
const SvgLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#link_svg__a)">
      <path d="M12.53 16.08h-.05a4.44 4.44 0 0 1-3.16-1.35 1 1 0 0 1 0-1.41 1 1 0 0 1 1.41 0 2.5 2.5 0 0 0 1.76.75 2.48 2.48 0 0 0 1.75-.71l4-4a2.51 2.51 0 0 0 .04-3.62 2.53 2.53 0 0 0-3.58 0l-.5.5a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.42l.5-.5a4.54 4.54 0 0 1 6.42 6.42l-4 4-.07.07a4.46 4.46 0 0 1-3.1 1.27" />
      <path d="M7.53 21.03a4.55 4.55 0 0 1-3.21-1.32 4.54 4.54 0 0 1 0-6.42l4-4 .07-.07a4.55 4.55 0 0 1 3.19-1.19 4.44 4.44 0 0 1 3.16 1.35 1 1 0 0 1 0 1.41 1 1 0 0 1-1.41 0 2.5 2.5 0 0 0-1.76-.75 2.48 2.48 0 0 0-1.75.71l-4 4a2.5 2.5 0 0 0-.79 1.78 2.5 2.5 0 0 0 .75 1.79 2.53 2.53 0 0 0 3.58 0l.5-.5a1 1 0 0 1 1.639.325 1 1 0 0 1-.22 1.095l-.5.5a4.55 4.55 0 0 1-3.249 1.29" />
    </g>
    <defs>
      <clipPath id="link_svg__a">
        <path fill="#fff" d="M3 3h18.07v18.07H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLink;
